const COUNTRY_CODES = [
  'AF','AL','DZ','AD','AO','AG','AR','AM','AU','AT','AZ','BS','BH','BD','BB',
  'BY','BE','BZ','BJ','BT','BO','BA','BW','BR','BN','BG','BF','BI','CV','KH',
  'CM','CA','CF','TD','CL','CN','CO','KM','CG','CD','CR','CI','HR','CU','CY',
  'CZ','DK','DJ','DM','DO','EC','EG','SV','GQ','ER','EE','SZ','ET','FJ','FI',
  'FR','GA','GM','GE','DE','GH','GR','GD','GT','GN','GW','GY','HT','HN','HU',
  'IS','IN','ID','IR','IQ','IE','IL','IT','JM','JP','JO','KZ','KE','KI','KW',
  'KG','LA','LV','LB','LS','LR','LY','LI','LT','LU','MG','MW','MY','MV','ML',
  'MT','MH','MR','MU','MX','FM','MD','MC','MN','ME','MA','MZ','MM','NA','NR',
  'NP','NL','NZ','NI','NE','NG','KP','MK','NO','OM','PK','PW','PA','PG','PY',
  'PE','PH','PL','PT','QA','RO','RU','RW','KN','LC','VC','WS','SM','ST','SA',
  'SN','RS','SC','SL','SG','SK','SI','SB','SO','ZA','KR','SS','ES','LK','SD',
  'SR','SE','CH','SY','TJ','TZ','TH','TL','TG','TO','TT','TN','TR','TM','TV',
  'UG','UA','AE','GB','US','UY','UZ','VU','VA','VE','VN','YE','ZM','ZW',
];

const ALIASES = {
  'united states of america': 'US',
  america: 'US',
  usa: 'US',
  'united kingdom': 'GB',
  england: 'GB',
  britain: 'GB',
  'great britain': 'GB',
  'saudi arabia': 'SA',
  ksa: 'SA',
  uae: 'AE',
  'united arab emirates': 'AE',
  'south korea': 'KR',
  korea: 'KR',
  'north korea': 'KP',
  russia: 'RU',
  syria: 'SY',
  iran: 'IR',
  vietnam: 'VN',
  'czech republic': 'CZ',
  'أمريكا': 'US',
  'الولايات المتحدة': 'US',
  'الولايات المتحدة الأمريكية': 'US',
  'بريطانيا': 'GB',
  'المملكة المتحدة': 'GB',
  'السعودية': 'SA',
  'المملكة العربية السعودية': 'SA',
  'الإمارات': 'AE',
  'الإمارات العربية المتحدة': 'AE',
  'كوريا الجنوبية': 'KR',
  'كوريا الشمالية': 'KP',
  'روسيا': 'RU',
  'سوريا': 'SY',
  'إيران': 'IR',
  'فيتنام': 'VN',
};

const normalize = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ');

const flagFromCode = (code) =>
  String(code || '')
    .toUpperCase()
    .replace(/./g, (char) =>
      String.fromCodePoint(127397 + char.charCodeAt(0))
    );

const displayNameCache = new Map();

function getRegionName(code, locale) {
  const key = `${locale}-${code}`;
  if (!displayNameCache.has(key)) {
    try {
      const display = new Intl.DisplayNames([locale], { type: 'region' });
      displayNameCache.set(key, display.of(code));
    } catch {
      displayNameCache.set(key, '');
    }
  }
  return displayNameCache.get(key);
}

export function getCountryCode(country) {
  const normalized = normalize(country);
  if (!normalized) return '';

  if (ALIASES[normalized]) return ALIASES[normalized];

  for (const code of COUNTRY_CODES) {
    const englishName = normalize(getRegionName(code, 'en'));
    const arabicName = normalize(getRegionName(code, 'ar'));
    if (normalized === englishName || normalized === arabicName) {
      return code;
    }
  }

  return '';
}

export function getCountryFlag(country) {
  const code = getCountryCode(country);
  return code ? flagFromCode(code) : '';
}

export function countryWithFlag(country) {
  const flag = getCountryFlag(country);
  return flag ? `${flag} ${country}` : country || '-';
}

export function getFlagImageUrl(country) {
  const code = getCountryCode(country);
  return code ? `https://flagcdn.com/w40/${code.toLowerCase()}.png` : '';
}
